

export class PickupDeliveryTypeEnum {
    
	static PickupDelivery: number = 0; 
	static HourlyPickupDelivery: number = 5; 
	static Move: number = 10; 
	static Return: number = 20; 
	static ServiceOnly: number = 30; 
	static WillCall: number = 40; 


	static getChoices(): any[] {
		return [
		{
			Value: PickupDeliveryTypeEnum.PickupDelivery, Text: 'Pickup Delivery'
	},{
			Value: PickupDeliveryTypeEnum.HourlyPickupDelivery, Text: 'Hourly Pickup Delivery'
	},{
			Value: PickupDeliveryTypeEnum.Move, Text: 'Move'
	},{
			Value: PickupDeliveryTypeEnum.Return, Text: 'Return'
	},{
			Value: PickupDeliveryTypeEnum.ServiceOnly, Text: 'Service Only'
	},{
			Value: PickupDeliveryTypeEnum.WillCall, Text: 'Will Call'
	}
			
		];
	}

}
